import AllBanners from './AllBanners.gql';

export default AllBanners;
